import { getProductCategoriesService } from '@/services/products';
import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Divider, MenuItem, Typography } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { RHFCheckbox, RHFSelect, RHFSlider } from '../../../components/hook-form';
import TableFilterDrawer from '../../../components/table/TableFilterDrawer';

export default function ProductFilterDrawer({ open, onClose, onSubmit }) {
  const productCategoriesQuery = useQuery({
    queryKey: ['product-categories'],
    queryFn: () => getProductCategoriesService(),
  });

  const schema = yup.object().shape({
    type: yup.string(),
    affiliateCommission: yup.array().of(yup.number()),
    affiliateRequest: yup.boolean(),
    affiliateContact: yup.boolean(),
    affiliateShareBump: yup.boolean(),
    affiliateShareUpsell: yup.boolean(),
    price: yup.array().of(yup.number()),
    category: yup.string().nullable(),
  });

  const { ...form } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      type: '',
      category: '',
      affiliateCommission: [1, 80],
      affiliateRequest: false,
      affiliateContact: false,
      affiliateShareBump: false,
      affiliateShareUpsell: false,
      price: [1, 20000],
    },
  });

  return (
    <TableFilterDrawer form={form} open={open} onClose={onClose} onSubmit={onSubmit}>
      <RHFSelect
        name="category"
        value={form.watch('category')}
        label="Categoria"
        size="small"
        disabled={productCategoriesQuery.isLoading}
      >
        {productCategoriesQuery.data?.map((category) => (
          <MenuItem key={category.id} value={category.id}>
            {category.name}
          </MenuItem>
        ))}
      </RHFSelect>

      <RHFSelect name="type" value={form.watch('type')} label="Tipo de produto" size="small">
        <MenuItem value="unique">Único</MenuItem>
        <MenuItem value="subscription">Assinatura</MenuItem>
      </RHFSelect>

      <Box sx={{ mt: 2, mb: 1 }}>
        <Typography variant="subtitle2" gutterBottom>
          Comissão: {form.watch('affiliateCommission')[0]}% - {form.watch('affiliateCommission')[1]}
          %
        </Typography>
        <RHFSlider name="affiliateCommission" value={form.watch("affiliateCommission")} min={1} max={80} step={1} />
      </Box>

      <Box sx={{ mt: 3, mb: 1 }}>
        <Typography variant="subtitle2" gutterBottom>
          Faixa de preço: R${form.watch('price')[0]} - R${form.watch('price')[1]}
        </Typography>
        <RHFSlider name="price" value={form.watch("price")} min={1} max={2000} step={25} />
      </Box>

      <Divider sx={{ my: 2 }} />

      <Typography variant="subtitle2" color="text.secondary" mb={1}>
        Ferramentas
      </Typography>
      <RHFCheckbox name="affiliateRequest" label="Solicitação de afiliado" size="small" />
      <RHFCheckbox name="affiliateContact" label="Contato de afiliado" size="small" />
      <RHFCheckbox name="affiliateShareBump" label="Compartilhar bump" size="small" />
      <RHFCheckbox name="affiliateShareUpsell" label="Compartilhar upsell" size="small" />
    </TableFilterDrawer>
  );
}

ProductFilterDrawer.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
};
